import { OPEN_BACKDROP, CLOSE_BACKDROP } from '#action/types';

const defaultState = { open: false };

export default (state = defaultState, action) => {
  switch (action.type) {
    case OPEN_BACKDROP:
      return { open: true };
    case CLOSE_BACKDROP:
      return { open: false };
    default:
      return state;
  }
};
